import React from "react"
import { createGlobalStyle, ThemeProvider } from "styled-components"
import { MDXProvider } from "@mdx-js/react"
import { preToCodeBlock } from "mdx-utils"
import Theme from "./src/themes/theme"
import { Table, Code } from "./src/components"
import "./language-tabs.css"

const GlobalStyles = createGlobalStyle`
    :root {
        --bg: #f4efe6;
        --elevated: #fbf7f0;
        --fg: #1c1915;
        --muted: #6b6459;
        --accent: #3d5a4c;
        --border: rgba(28, 25, 21, 0.12);
        --font-serif: "Newsreader", "Iowan Old Style", Palatino, Georgia, serif;
        --font-sans: "Figtree", system-ui, sans-serif;
        --radius-sm: 0.375rem;
        --radius-md: 0.75rem;
        --radius-lg: 1.25rem;
        --measure: 65ch;
        --header-h: 4rem;
        color-scheme: light;
    }

    [data-theme="dark"] {
        --bg: #161411;
        --elevated: #1e1b17;
        --fg: #f4efe6;
        --muted: #a39b8e;
        --accent: #c4b5a0;
        --border: rgba(244, 239, 230, 0.12);
        color-scheme: dark;
    }

    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }

    html {
        scroll-behavior: smooth;
    }

    body, html {
        font-family: ${props => props.theme.fonts.main};
        min-height: 100%;
        color: var(--fg);
        background-color: var(--bg);
        line-height: 1.6;
        -webkit-font-smoothing: antialiased;
    }

    h1, h2, h3, h4, h5 {
        font-family: var(--font-serif);
        font-weight: 600;
        line-height: 1.25;
        color: var(--fg);
    }

    img {
        max-width: 100%;
        height: auto;
        display: block;
    }

    a {
        color: var(--accent);
        text-underline-offset: 0.18em;
    }

    button {
        font-family: inherit;
        cursor: pointer;
    }

    :focus-visible {
        outline: 2px solid var(--accent);
        outline-offset: 3px;
    }
`

const components = {
    table: Table,
    pre: preProps => {
        const props = preToCodeBlock(preProps)
        // check if there is codeString and props
        if (props) {
            return <Code {...props} />
        }
        // return a pre without a code in it
        return <pre {...preProps} />
    },
    wrapper: ({ children }) => <>{children}</>,
}


export const wrapRootElement = ({ element }) => (
    <MDXProvider components={components}>
        <ThemeProvider theme={Theme}>
            <GlobalStyles />
            {element}
        </ThemeProvider>
    </MDXProvider>
)
